
module.exports = { 
      attributes: {},
    
      body: "Hearing services supports those who are at risk of losing their hearing or have lost their hearing.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/hearing-services.md"},
     }